<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row align-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Carrier Links</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container>
			<b-row>
				<b-col xl="12">
					<b-card no-body>
						<b-card-body>
							<div class="text-center w-100">
								<b-icon
									icon="three-dots"
									class="text-center"
									animation="cylon"
									font-scale="4"
									v-if="loadingStatus"
								></b-icon>
							</div>
							<div v-if="!loadingStatus">
								<b-button
									v-if="portalAdminStatus"
                  data-cy="add-link-btn"
									v-b-modal.add-link
									size="sm"
									variant="success"
									class="mb-3 float-right"
								>
									+ Add New Link
								</b-button>
								<b-row>
									<b-col cols="12" xl="8" lg="7" md="7" sm="6">
										<b-form-group
											label=""
											label-for="per-page-select"
											label-cols-sm="0"
											label-cols-md="0"
											label-cols-lg="0"
											label-align-sm="center"
											label-size="sm"
											class="mb-2 per-page-select"
										>
											<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
											<b-form-select
												id="per-page-select"
												class="diameter-report-select"
												v-model="perPage"
												:options="pageOptions"
												size="sm"
												v-on:input="getTotalRows"
											></b-form-select>
										</b-form-group>
									</b-col>
									<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
										<b-form-group
											label=""
											label-for="filter-input"
											label-align-sm="right"
											label-size="sm "
											class="mb-0 per-page-select"
										>
											<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
											<b-input-group size="sm">
												<b-form-input
													id="filter-input2"
													v-model="filter"
													class="mb-4"
												></b-form-input>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-table
									:fields="fields"
									:items="items"
									:current-page="currentPage"
									:per-page="perPage"
									:filter="filter"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									:sort-direction.sync="sortDirection"
									class="text-center primary-table"
									hover
									responsive
									show-empty
									small
									striped
									@filtered="onFiltered"
								>
									<template #cell(actions)="row">
										<span class="text-center">
											<i
												v-if="defaultPaths.indexOf(row.item.link) === -1 && portalAdminStatus"
												class="fas fa-trash-alt mr-3 cursor-pointer text-danger"
												v-on:click="deleteMenuLink(row.item)"
												v-b-tooltip.hover
												title="Delete Link"
											></i>
											<i
												v-else-if="portalAdminStatus"
												class="fas fa-trash-alt mr-3 text-light"
												v-b-tooltip.hover
												title="Cannot Delete Default Link"
											></i>
											<i
												class="fas fa-pen-nib cursor-pointer text-success"
												v-b-modal.edit-link
												v-on:click="editLink(row.item)"
												v-b-tooltip.hover
												title="Edit Link"
											></i>
										</span>
									</template>
									<template #cell(name)="row">
										<span class="nowrap" v-b-tooltip.hover :title="row.item.desc">
											<span>
												<i
													:class="row.item.icon"
													:style="{
														color: row.item.color,
														fontSize: '1rem',
														marginRight: '0.5rem',
													}"
												></i>
												{{ row.item.name }}
											</span>
										</span>
									</template>
									<!-- <template #cell(path)="row">
										<a :href="row.value">
											{{ row.value }}
										</a>
									</template> -->
									<template #cell(link)="row">
										<a :href="row.value">
											{{ row.value }}
										</a>
									</template>
									<template #cell(role)="row">
										<span>
											<tags-input
												input-id="tags-pills"
												v-model="row.item.role"
												:userName="row.item.name"
												tag-type="danger"
												size="sm"
												no-add-on-enter
												no-outer-focus
												:closable="false"
											>
											</tags-input>
										</span>
									</template>
								</b-table>
							</div>
							<b-row class="mt-4" v-if="items.length > 0">
								<b-col> Showing {{ startPage() }} - {{ lastPage() }} of {{ totalRows }} entries </b-col>
								<b-col xl="auto" md="auto" sm="auto ">
									<b-pagination
										class="flex-fill-custom pr-4"
										v-model="currentPage"
										:total-rows="totalRows"
										:per-page="perPage"
										size="sm"
									></b-pagination>
								</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<b-modal
			centered
			size="lg"
			id="add-link"
			hide-footer
			title="Add New Menu Link"
			class="Add-User"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<AddLinkModal></AddLinkModal>
		</b-modal>
		<b-modal
			centered
			size="lg"
			id="edit-link"
			hide-footer
			title="Edit Menu Link"
			class="Change-User"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<EditLinkModal v-if="portalAdminStatus"></EditLinkModal>
			<EditLinkSimpleModal v-else></EditLinkSimpleModal>
		</b-modal>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import AuthService from "@/common/api-services/auth-service";
import AddLinkModal from "../../../views/Components/AddLink.vue";
import EditLinkModal from "../../../views/Components/EditLink.vue";
import EditLinkSimpleModal from "../../../views/Components/EditLinkSimple.vue";
import TagsInput from "@/components/Inputs/TagsInput";
import pagination from "../../../common/format/pagination";
import handleResponse from "../../../common/directive/handlResponse";
import configDirective from "../../../common/directive/config-directive";
import swal from "sweetalert2";
import initService from "../../../common/api-services/init-service";

export default {
	name: "Menu-Links",
	components: {
		RouteBreadCrumb,
		AddLinkModal,
		EditLinkModal,
		EditLinkSimpleModal,
		TagsInput,
	},
	mounted() {
		document.title = "Administrator - Carrier Links";
		this.origin = window.location.origin;
		this.adminStatus = initService.getAdministratorRole();
		this.portalAdminStatus = initService.getPortalAdminRole();
		this.getMenuLinks();
		this.customer = configDirective.getCarrier().charAt(0).toUpperCase() + configDirective.getCarrier().slice(1);

		this.$root.$on("refreshMenuLinks", () => {
			this.$store.dispatch("getMenuLinks", true);
			this.getMenuLinks();
		});

		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			adminStatus: false,
			portalAdminStatus: false,
			loadingStatus: false,
			items: [],
			fields: [
				{key: "actions", label: "Actions", sortable: false},
				// {key: "state", label: "", sortable: false},
				{key: "name", label: "Name", sortable: true},
				// {key: "path", label: "Path", sortable: true},
				{key: "link", label: "Link", sortable: true},
				{key: "group", label: "Group", sortable: true},
				{key: "role", label: "Roles", sortable: true},
				// {key: "created", label: "Date Created", sortable: true},
				{key: "updated", label: "Last Updated", sortable: true},
			],
			defaultPaths: ["/admin/carrier_links", "/admin/user_admin"],
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			totalRows: 0,
			sortBy: "group",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			customer: "",
			origin: "",
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);
			if (this.portalAdminStatus) {
				// portal admin access override
				return false;
			} else if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
	},
	methods: {
		async getMenuLinks() {
			this.items = [];
			this.totalRows = 0;
			this.currentPage = 1;
			let arr = [];
			this.loadingStatus = true;
			await AuthService.getMenuLinks("All", true)
				.then(response => {
					response.message.results.forEach(item => {
						arr.push({
							id: item.id,
							order: item.order,
							name: item.name,
							desc: item.description,
							link: item.link,
							group: item.group,
							icon: item.icon,
							color: item.icon_color,
							created: item.created,
							updated: item.modified,
							type: item.attr_type,
							role: item.roles.toUpperCase().split(","),
						});
					});
				})
				.catch(err => {
					if (process.env.NODE_ENV === "dev") console.error(err);
				})
				.finally(() => {
					this.loadingStatus = false;
					this.items = arr;
					this.totalRows = this.items.length;
				});
		},

		deleteMenuLink(link) {
			// console.log(link);
			swal.fire({
				title: `DELETE ${link.name} Link`,
				text: `Delete ${this.customer}'s ${link.name} nav link?`,
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: "Delete",
				cancelButtonText: "Cancel",
				customClass: {
					cancelButton: 'order-1 mr-3',
					confirmButton: 'btn btn-danger order-2',
				},
			}).then(result => {
				if (result.isConfirmed) {
					this.loadingStatus = true;
					AuthService.deleteMenuLink(link.id)
						.then(res => {
							let {type, msg} = handleResponse.apiResponse(res);
							if (type === "success") {
								this.$root.$emit("refreshMenuLinks");
								this.$toast.success(`${link.name} link deleted successfully!`);
							} else {
								console.error(msg);
								this.$toast.error(msg);
							}
						})
						.catch(err => {
							let {type, msg} = handleResponse.apiResponse(err);
							console.error(err);
							this.$toast(type, msg);
						})
						.finally(() => {
							this.loadingStatus = false;
						});
				}
			});
		},

		editLink(item) {
			setTimeout(() => {
				this.$root.$emit("editLink", item);
			});
			// this.$root.$emit("editLink", item);
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},

		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
};
</script>

<style scoped></style>
